import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Deadline from '../../entities/deadline';

/*
 * Delete/nullify anywhere this deadline is used in other entities
 *
 * @param {Deadline} deadline
 */
export function deleteDeadline(deadline: Deadline, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = deadline.id;
    }

    /* Remove the actual deadline */
    deadline.status = 'D';
    deadline.addedOn = newHRTimestamp();
    deadline.addedBy = getCurrentUserId();
    deadline.importSource = targetImportSource;
    deadline.importId = mergeId;
    store.dispatch(Actions.DeadlineActions.removeDeadlineQueue(deadline));
    
}